<!-- 首页种植计算列表：标题+日期（右边） -->
<template>
<div class="info-block">
  <router-link class="info-block-a" :title="info.title" :to="'/hyzx/details/'+info.id" target="_blank">
    <div class="title">{{info.title.length>titleLength?(info.title.substring(0,titleLength)+'...'):info.title}}</div>
    <div class="date">{{info.create_time.length>10?(info.create_time.substring(5,10)):info.create_time}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'InfoBlock09',
  props: {
    info: {
      type: Object,
      default: {}
    },
    titleLength:{
      type:Number|String,
      default:15
    },
    labelLength:{
      type:Number|String,
      default:28
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:border-box;
  height:30px;
  width:100%;
  padding:0px 60px 0px 0px;
  margin-bottom:10px;
  border:0px solid #fff;
  background-color: #fff;
  background-size: 120px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  //border:1px solid #eee;
  color:var(--color6);
  //box-shadow:0px 0px 1px 1px orange;
}

.info-block .info-block-a:hover > .title{
  color:var(--color6);
}

.info-block-a .title{
  position:relative;
  height:30px;
  font-size:14px;
  font-weight:500;
  color:#282A2B;
  line-height:30px;

}

.info-block-a .date{
  position:absolute;
  top:0px;
  right:0px;
  height:30px;
  padding-right:1px;
  font-size:12px;
  color:#9FA2A6;
  line-height:30px;
  color:#888;

}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock09.vue